const Error404 = () => {
  return <div>404 error</div>;
};

export default Error404;
